<template lang="pug"> 
  header.navbar.navbar-default.navbar-static-top
    // start: NAVBAR HEADER
    .navbar-header
      a.sidebar-mobile-toggler.pull-left.hidden-md.hidden-lg.sidebar-toggle(href='#', data-toggle-class='app-slide-off', data-toggle-target='#app', data-toggle-click-outside='#sidebar')
        i.ti-align-justify
      router-link.navbar-brand(to='/')
        img(src='/static/app/images/logo.png', alt='Salesbeat')
      a.sidebar-toggler.pull-right.visible-md.visible-lg(href='#', data-toggle-class='app-sidebar-closed', data-toggle-target='#app')
        i.ti-align-justify
      a#menu-toggler.pull-right.menu-toggler.visible-xs-block(data-toggle='collapse', href='.navbar-collapse')
        span.sr-only Toggle navigation
        i.ti-view-grid
    // end: NAVBAR HEADER
    // start: NAVBAR COLLAPSE
    .navbar-collapse.collapse
        //- .header-shop-name
            h3  {{ selectedShop.name }}     
        
        select-shop.hidden-xs

        ul.nav.navbar-right
            nav-bar.nav.navbar-right.visible-xs-block(
                data-toggle="collapse", 
                href=".navbar-collapse"
            )

            li(v-if="isPartner || isStaff")
                router-link.dropdown-toggle(:to="{name: 'PartnerShops'}")
                    i.fa.fa-money
                    |  Ваши магазины

            li(v-if="isStaff")
                router-link.dropdown-toggle(to='/finance')
                    i.ti-stats-up
                    |  Финансы

            // start: USER OPTIONS DROPDOWN
            li.dropdown.current-user.hidden-xs
              a.dropdown-toggle(href='', data-toggle='dropdown')
                span.username
                  | {{ userFullName }}
                  i.ti-angle-down
              nav-bar.dropdown-menu.dropdown-dark(
                    data-toggle="collapse", 
                    href=".navbar-collapse"
              )
        // end: USER OPTIONS DROPDOWN
        // start: MENU TOGGLER FOR MOBILE DEVICES
        .close-handle.visible-xs-block.menu-toggler(data-toggle='collapse', href='.navbar-collapse')
            .arrow-left
            .arrow-right
        // end: MENU TOGGLER FOR MOBILE DEVICES
    // end: NAVBAR COLLAPSE

</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters, mapMutations } from 'vuex';

import Navbar from './Navbar';
import SelectShop from './SelectShop';

export default {
    name: 'Header',
    created() {
        this.$store.dispatch('loadShops');
    },
    components: {
        'nav-bar': Navbar,
        'select-shop': SelectShop
    },
    computed: {
        ...mapState({
            openedMenuItem: 'openedMenuItem',
            // selectedShop: state => state.localStorage.selectedShop,
            isStaff: state => state.users.profile.is_staff,
            isPartner: state => state.users.profile.is_partner,
            userFullName: state => [state.users.profile.first_name || '',
                state.users.profile.last_name || ''].join(' ')
        }),
        ...mapGetters(['companies'])
    }
};
</script>

<style>
.header-shop-name {
    margin-top: 20px;
    margin-left: 15px;
    display: inline-block;
}
@media (max-width: 767px) {
    .header-shop-name {
        margin-left: 0px;
        text-align: center;
        width: 100%;
    }
}
.header-shop-name h3 {
  color: #e0e2e4;
}
.navbar .navbar-header .menu-toggler {
  margin-right: 0;
}
.navbar-collapse ul.nav.navbar-right {
  margin-right: 0;
}
.navbar .navbar-header .navbar-brand img {
  margin-right: -20px;
}
.companies-list {
    width: 500px;
    max-height: 90vh;
    overflow: scroll;
}
.companies-list div {
    /*padding-left: 10px;*/
    display: list-item;
    text-align: -webkit-match-parent;
    border-radius: 7px 7px 0 0;
    border-bottom: 1px solid #DDDDDD;
    font-size: 14px;
    /*line-height: 35px;*/
    line-height: 1.3em;
    padding: 10px;
    text-align: left;
}
.dropdown-item {
    border-bottom: 1px solid #ddd;
    font-size: 14px;
    line-height: 35px;
    color: #007aff;
    display: block;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue